module.exports = __webpack_public_path__ + "officialStatic/img/businessRh.8db6307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/businessRh.png
// module id = HeUq
// module chunks = 0